import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {  ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';

import { Root } from "./root";
import { gqlAgentMyAccount } from './services/agent';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <ApolloProvider client={gqlAgentMyAccount}>
    <Root />
    </ApolloProvider>
    </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
